import FooterAccordion from './FooterAccordion';

export default FooterAccordion;
